import React from 'react';
import { AVATARS } from '../constants/avatars.jsx';
import './AvatarPicker.css';

export default function AvatarPicker({ value, onChange }) {
  return (
    <div className="field">
      <label id="avatar-label">เลือกสัญลักษณ์ประจำตัว</label>
      <div className="avatar-grid" role="radiogroup" aria-labelledby="avatar-label">
        {AVATARS.map((a) => {
          const IconComp = a.icon;
          const isSelected = value === a.id;
          return (
            <button
              key={a.id}
              type="button"
              role="radio"
              aria-checked={isSelected}
              aria-label={a.label}
              className={`avatar-option ${isSelected ? 'is-selected' : ''}`}
              onClick={() => onChange(a.id)}
              style={{
                '--avatar-bg': a.bg,
                '--avatar-color': a.color,
              }}
              title={a.label}
            >
              <IconComp size={22} />
            </button>
          );
        })}
      </div>
    </div>
  );
}
